module.exports = __webpack_public_path__ + "static/media/12.78cb0758.jpg";